import moment from 'moment-timezone';

import { DEFAULT_TIME } from './texts';

/**
 * @typedef {object} DateRangeValue
 * @property {string} from ISO-8601.
 * @property {string} to ISO-8601.
 */

/**
 * @typedef {object} TimeViewData
 * @property {string} shownValue `HH:mm` string displayed in the input.
 * @property {boolean} disabled True when there is no range → input is inert.
 * @property {boolean} showResetIcon True when the user has changed the time
 *   away from the default (there is something to reset).
 */

/**
 * Build display state for the time input from the current store range.
 *
 * @param {DateRangeValue | null | undefined} dateRangeValue
 * @returns {TimeViewData}
 */
export const buildTimeViewData = (dateRangeValue) => {
	const shownValue = dateRangeValue ? moment(dateRangeValue.from).format('HH:mm') : DEFAULT_TIME;
	return {
		shownValue,
		disabled: !dateRangeValue,
		showResetIcon: shownValue !== DEFAULT_TIME,
	};
};
